// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; 
import AfterSchoolEnrichmentBody from '../../components/internal/SegueK-8/AfterSchoolEnrichment/AfterSchoolEnrichmentBody';

function K8AfterSchoolEnrichment() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <AfterSchoolEnrichmentBody />
      <Footer />
    </>
  );
}

export default K8AfterSchoolEnrichment;